document.addEventListener('DOMContentLoaded', function () {
  console.log('Script loaded successfully'); // Check if the script is running

  const variantSelector = document.querySelector('#variant');
  const quantityInput = document.querySelector('#quantity');
  const currentPriceEl = document.querySelector('#current-price');
  const originalPriceEl = document.querySelector('#original-price');
  const savingsValueEl = document.querySelector('#savings-value');

  if (!currentPriceEl || !originalPriceEl || !savingsValueEl) {
    console.error('Pricing elements not found');
    return;
  }

  const updatePricing = () => {
    console.log('Updating pricing...');
    const selectedVariant = variantSelector ? variantSelector.options[variantSelector.selectedIndex] : null;
    const variantPrice = selectedVariant ? parseFloat(selectedVariant.dataset.price) : parseFloat(document.querySelector('.pricing').dataset.originalPrice);

    if (isNaN(variantPrice)) {
      console.error('Variant price not found or invalid');
      return;
    }

    const discountPercentage = 10; // Discount percentage
    const discountValue = (variantPrice * discountPercentage) / 100;
    const discountedPrice = variantPrice - discountValue;
    const quantity = parseInt(quantityInput.value, 10);

    // Update pricing display
    currentPriceEl.textContent = `$${(discountedPrice * quantity).toFixed(2)}`;
    originalPriceEl.textContent = `$${(variantPrice * quantity).toFixed(2)}`;
    savingsValueEl.textContent = `$${(discountValue * quantity).toFixed(2)}`;

    console.log(`Updated prices: Current - $${discountedPrice}, Original - $${variantPrice}, Savings - $${discountValue}`);
  };

  // Event listeners for quantity and variant changes
  if (variantSelector) {
    console.log('Variant selector found');
    variantSelector.addEventListener('change', updatePricing);
  } else {
    console.warn('Variant selector not found');
  }

  if (quantityInput) {
    quantityInput.addEventListener('input', updatePricing);
    document.querySelectorAll('.decrease').forEach(button => {
      button.addEventListener('click', function () {
        const currentValue = parseInt(quantityInput.value, 10);
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
          updatePricing();
        }
      });
    });
    document.querySelectorAll('.increase').forEach(button => {
      button.addEventListener('click', function () {
        const currentValue = parseInt(quantityInput.value, 10);
        quantityInput.value = currentValue + 1;
        updatePricing();
      });
    });
  } else {
    console.warn('Quantity input not found');
  }

  // Initial pricing update
  updatePricing();
});
